export const setDetails = (details: any) => ({
  type: 'SET_DETAILS',
  payload: details,
});

export const resetDetails = () => ({
  type: 'RESET_DETAILS',
  payload: null,
});
